module.exports = __webpack_public_path__ + "static/media/money-icon.5a95392d.svg";